import { ReactReduxContextValue, createSelectorHook } from 'react-redux';
import { Context } from 'react';

import { StateContext } from '../contexts';

const useAppSelector = createSelectorHook(
  StateContext as Context<ReactReduxContextValue<any, any>>,
);

export default useAppSelector;
